import { RefObject } from "react";

const ORIGINAL_IMAGE_ROI_SIZE = 100;

export const calculateRoiSquareSize = (
  imageRef: RefObject<HTMLImageElement>,
  e: any,
) => {
  if (imageRef.current) {
    const { naturalHeight } = e.target;
    return (
      (imageRef.current.clientHeight / naturalHeight) * ORIGINAL_IMAGE_ROI_SIZE
    );
  }
  return 0;
};
